/* RESPONSIBLE TEAM: team-inbox-experience */
import DefaultPredicateManager from 'embercom/lib/common/predicates/default-predicate-manager';

export default DefaultPredicateManager.extend({});
